<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查任务详情
      </div>
    </div>
    <el-form ref="form" :model="list" label-width="110px" class="mt20">
      <el-row :gutter="10">
        <el-form-item label="项目名称:" prop="itemName">
          {{ list.itemName }}
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-form-item label="开始时间:" prop="startTime">
          {{ list.startTime }}
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-form-item label="结束时间:" prop="endTime">
          {{ list.endTime }}
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-form-item label="当前进度:" prop="currentProgress">
          {{ list.currentProgress }}
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-form-item label="巡查人员:" prop="inspector">
          {{ list.inspector }}
        </el-form-item>
      </el-row>
    </el-form>
    <div class="content_line"></div>
    <h2 class="content">巡查详情</h2>
    <el-table :data="list.itemPointRecord" class="mt10" ref="multipleTable">
      <el-table-column
        prop="pointName"
        label="巡查点位"
        align="center"
      ></el-table-column>
      <el-table-column
        label="巡查时间"
        align="center"
      >
       <template slot-scope="scope">
        <div v-if="scope.row.status==0">
            --
        </div>
        <div v-else>
             {{scope.row.inspectTime}}
        </div>
      </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="巡查人"
      >
      <template slot-scope="scope">
        <div v-if="scope.row.status==0">
            --
        </div>
        <div v-else>
             {{scope.row.nickName}}
        </div>
      </template></el-table-column>
      <el-table-column
        align="center"
        label="状态"
      >
       <template slot-scope="scope">
        <div v-if="scope.row.pointStatus==null">
            --
        </div>
        <div v-else-if="scope.row.pointStatus==1">
             正常
        </div>
        <div v-else-if="scope.row.pointStatus==2">
             待审核
        </div>
        <div v-else-if="scope.row.pointStatus==3">
             待复核
        </div>
        <div v-else-if="scope.row.pointStatus==4">
             待整改
        </div>
        <div v-else-if="scope.row.pointStatus==5">
             已整改
        </div>
      </template>
      </el-table-column>
      <el-table-column
        prop="areaName"
        align="center"
        label="操作"
      >
      <template slot-scope="scope">
        <div v-if=" scope.row.recordId==null">
            --
        </div>
        <div v-else>
             <router-link
                :to="{
                  path: '/wenlv/inspectionRecordDetail',
                  query: { id: scope.row.recordId },
                }"
              >
                <div style="color:rgb(74,169,255)">查看</div>
              </router-link>
        </div>
       
      </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
      list: {},
    };
  },

  created() {
    this.getList();
  },
  methods: {
    getList() {
      console.log(this.id);
      this.$get("/relic/relicInspectionItem/getInfo/" + this.id).then((res) => {
        console.log(res);
        this.list = res.data;
      });
    },
  },
};
</script>
<style scoped>
.content {
  display: inline-block;
  margin-left: 30px;
  width: 15%;
}
.content_line {
  width: 100%;
  height: 20px;
  margin-left: 10px;
  margin-bottom: 15px;
  border-bottom: 1px dashed rgb(182, 182, 182);
}
</style>
